export const linkCardsExtensionType = 'com.atlassian.confluence.link-cards';
